import { render, staticRenderFns } from "./AdminBanners.vue?vue&type=template&id=c7c12c9c&"
import script from "./AdminBanners.vue?vue&type=script&lang=js&"
export * from "./AdminBanners.vue?vue&type=script&lang=js&"
import style0 from "./AdminBanners.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7c12c9c')) {
      api.createRecord('c7c12c9c', component.options)
    } else {
      api.reload('c7c12c9c', component.options)
    }
    module.hot.accept("./AdminBanners.vue?vue&type=template&id=c7c12c9c&", function () {
      api.rerender('c7c12c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminBanners.vue"
export default component.exports